var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("Letzte Aktualisierung: "+_vm._s(_vm.transformed))])])])}
var staticRenderFns = []

export { render, staticRenderFns }